import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import cn from 'classnames';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import { LT_ROUTE } from 'bl/loggers.bl';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import { useTranslation } from 'providers/GILT.provider';
import { NcobSettingsProvider } from 'providers/NcobSettings.provider';
import { withTheme } from 'providers/Theme.provider';
import { selectCurrentSalonId, selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import logger from 'utils/logger.util';

import TopNav from 'common/TopNav.component';
import OnlineBookingMenu from 'settings/online-booking/OnlineBookingMenu.component';
import OnlineBookingSetup from 'settings/online-booking/OnlineBookingSetup';
import BookingTimingsPanel from 'settings/online-booking/pages/booking-timings/BookingTimingsPanel.component';
import BrandingPanel from 'settings/online-booking/pages/branding/BrandingPanel.component';
import PolicyPage from 'settings/online-booking/pages/policy/PolicyPage.component';
import TextAlertsPage from 'settings/online-booking/pages/text-alerts/TextAlertsPage.component';
import EVouchersPage from 'settings/online-booking/pages/vouchers/EVouchersPage.component';

import CN from './OnlineBookingPage.module.scss';

const CTAG = 'OnlineBookingPage';
const L = logger([CTAG, LT_ROUTE]);

const OnlineBookingPage = ({ salonId, fetchStylistsBySalon, isDarkMode }) => {
  const { t } = useTranslation();

  useEffect(() => void L.unignore('useEffect()', 'fetchStylistsBySalon:', fetchStylistsBySalon(salonId)), [fetchStylistsBySalon, salonId]);

  return (
    <NcobSettingsProvider>
      <div
        data-bem="OnlineBookingPage"
        className={cn({
          [CN.component]: true,
          [CN.darkMode]: isDarkMode,
        })}
      >
        <TopNav title={t('onlineBooking.pageTitle')}>
          <SidebarMenu />
        </TopNav>

        <div data-bem="OnlineBookingPage__layout" className={CN.layout}>
          <div data-bem="OnlineBookingPage__menuContainer" className={CN.menuContainer}>
            <OnlineBookingMenu />
          </div>
          <div data-bem="OnlineBookingPage__pageContainer" className={CN.pageContainer}>
            <Switch>
              <Route exact path="/salon/:id/onlinebooking/settings" component={OnlineBookingSetup} />
              <Route exact path="/salon/:id/onlinebooking/branding" component={BrandingPanel} />
              <Route exact path="/salon/:id/onlinebooking/booking-timings" component={BookingTimingsPanel} />
              <Route exact path="/salon/:id/onlinebooking/policy" component={PolicyPage} />
              <Route exact path="/salon/:id/onlinebooking/text-alerts" component={TextAlertsPage} />
              <Route exact path="/salon/:id/onlinebooking/e-vouchers" component={EVouchersPage} />
            </Switch>
          </div>
        </div>
      </div>
    </NcobSettingsProvider>
  );
};

const OnlineBookingPageHoc = connect(
  (state) => ({
    stylists: selectCurrentSalonStylists(state),
    salonId: selectCurrentSalonId(state),
  }),
  (dispatch) => bindActionCreators({ fetchStylistsBySalon }, dispatch),
)(withTheme({ hasBright: true })(OnlineBookingPage));

export default OnlineBookingPageHoc;
